<div class="col-xs-12 ng-scope">
	<pannel
		[pannelClass]="pannelClass"
		[expandable]="true"
		[title]="title"
		[headerTemplate]="widgetHeaderPannelTemplate"
		[(folded)]="folded"
		(foldedChange)="onFoldedChange($event)"
		>
		<ng-content></ng-content>
	</pannel>
</div>

<ng-template #widgetHeaderPannelTemplate>
	<a	click-stop-propagation 
		[attr.alt]="alt"
		[attr.title]="alt"
		[attr.href]="href"
		>
		<i [ngClass]="iconClass" style="margin-right: 10px;">&nbsp;</i>{{ title }}
	</a>	
	<button class="btn btn-primary btn-sm pull-right">
		<span>{{ folded ? 'Afficher' : 'Masquer' }}</span>
	</button>
</ng-template>